<template>
  <v-form
    ref="form"
    v-model="valid"
    lazy-validation>
    <v-card dark class="chart">
      <!-- <v-card-title>Add chart</v-card-title> -->
      <!--<v-toolbar flat>-->
        <!--<v-toolbar-title>Add chart</v-toolbar-title>-->
        <!--<v-spacer></v-spacer>-->
        <!--<v-btn @click="$emit('close')" icon>-->
          <!--<v-icon>close</v-icon>-->
        <!--</v-btn>-->
      <!--</v-toolbar>-->
      <v-card-text style="min-height: 300px;">
        <v-text-field
          v-model="chartName"
          :rules="allRules"
          label="Chart name"
          @change="preview"
          required/>
      <div v-if="chartType ==='x-pie'">
        <v-select
          v-model="chartType"
          :items="chartTypeOptions"
          :rules="allRules"
          label="Chart type"
          v-if="chartFunc='count'"
          @change="preview"
          required/>
      </div>
      <div v-else>
        <v-select
          v-model="chartType"
          :items="chartTypeOptions"
          :rules="allRules"
          label="Chart type"
          @change="preview"
          required/>
      </div>
        <v-select
          v-model="index_now"
          :items="index_list"
          :rules="allRules"
          label="Device"
          @change="setRefreshIndex(); preview();"
          required/>
        <div v-if="chartType === 'x-sankey'">
          <v-select
            v-model="chartFunc"
            :items="chartFieldByteOptions"
            :rules="allRules"
            label="Sort by"
            @change="preview"
            required/>
          <v-text-field
            v-model="chartTopLimitSankey"
            :rules="allRules"
            label="Size of data in the chart (Default 5)"
            @change="preview"
            required/>
          <v-layout
            align-center
            justify-space-around>
          </v-layout>
          <v-layout>
          <v-autocomplete
            v-model="chartFieldStart"
            :items="chartFieldOptions"
            :rules="allRules"
            :label="'Dashboard field Start('+ chartFieldOptions.length+' Field available)'"
            @change="preview"
            required>
            <v-slide-x-reverse-transition
              slot="append-outer"
              mode="out-in"/>
          </v-autocomplete>
          </v-layout>
          <v-layout>
          <v-autocomplete
            v-model="chartFieldEnd"
            :items="chartFieldOptions"
            :rules="allRules"
            :label="'Dashboard field End('+ chartFieldOptions.length+' Field available)'"
            @change="preview"
            required>
            <v-slide-x-reverse-transition
              slot="append-outer"
              mode="out-in"/>
          </v-autocomplete>
          </v-layout>
          <v-layout
            align-center
            justify-space-around>
          <v-flex sm5 mt-1 ml-1>
            <v-checkbox
              v-model="show_all_field"
              label="Advanced Field"
            ></v-checkbox>
            <!--<toggle-button :sync="true"-->
            <!--:value="false"-->
            <!--width="110"-->
            <!--height="26"-->
            <!--font-size="11"-->
            <!--v-model="show_all_field"-->
            <!--:labels="{checked: 'All Field', unchecked: 'Poppular Field'}"-->
            <!--:color="{checked: '#53A34E', unchecked: '#7B2119'}"/>-->
          </v-flex>
          </v-layout>
          <v-text-field
            v-model="subFilter"
            :rules="allRules"
            label="Filter (Default *)"
            @change="preview"
            required/>
        </div>
        <div v-else-if="chartType === 'x-table'">
          <v-layout
            align-center
            justify-space-around>
          </v-layout>
          <v-autocomplete
            v-for="(item, index) in xTableItems"
            v-model="item.value"
            :items="chartFieldOptions"
            :key="index"
            :rules="allRules"
            @change="preview"
            :label="'Select Field Table ('+ chartFieldOptions.length+' Field available)'"
            perpend-icon="table_chart">
            <v-slide-x-reverse-transition
              slot="append-outer"
              mode="out-in">
              <v-icon
                :color="'warning'"
                @click="xTableItems.splice(index, 1) ; preview();"
                v-text="'delete'"/>
            </v-slide-x-reverse-transition>
          </v-autocomplete>
          <v-layout
            align-center
            justify-space-around>
            <v-icon
              @click="xTableItems.push({ value: '' })">playlist_add</v-icon>
            <v-flex sm5 mt-1 ml-1>
              <v-checkbox
                v-model="show_all_field"
                label="Advanced Field"
              ></v-checkbox>
              <!--<toggle-button :sync="true"-->
              <!--:value="false"-->
              <!--width="110"-->
              <!--height="26"-->
              <!--font-size="11"-->
              <!--v-model="show_all_field"-->
              <!--:labels="{checked: 'All Field', unchecked: 'Poppular Field'}"-->
              <!--:color="{checked: '#53A34E', unchecked: '#7B2119'}"/>-->
            </v-flex>
          </v-layout>
          <v-text-field
            v-model="subFilter"
            :rules="allRules"
            label="Filter (Default *)"
            @change="preview"
            required/>
        </div>
        <div v-else-if="chartType === 'x-tableCustom'">
          <!-- <v-select
            v-model="timestamp"
            :items="timestamp"
            item-text="text"
            item-value="value"
            label="Select Field Table"
            @change="preview"
            disabled
          /> -->
          <v-autocomplete v-model="item.value" :rules="allRules" v-for="(item, index) in xTableItems" :key="index"
            :items="chartFieldOptions"
            :label="'Select Field Table ('+ chartFieldOptions.length+' Field available)'"
            perpend-icon="table_chart"
            @change="preview"
          >
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in">
              <v-icon :color="'warning'" @click="xTableItems.splice(index, 1); preview();" v-text="'delete'"/>
            </v-slide-x-reverse-transition>
          </v-autocomplete>
          <v-layout align-center justify-space-around>
            <v-icon @click="xTableItems.push({ value: '' })" v-if="xTableItems.length < 4">playlist_add</v-icon>
            <v-flex sm5 mt-1 ml-1>
              <v-checkbox
                v-model="show_all_field"
                label="Advanced Field"
              ></v-checkbox>
              <!--<toggle-button :sync="true"-->
              <!--:value="false"-->
              <!--width="110"-->
              <!--height="26"-->
              <!--font-size="11"-->
              <!--v-model="show_all_field"-->
              <!--:labels="{checked: 'All Field', unchecked: 'Poppular Field'}"-->
              <!--:color="{checked: '#53A34E', unchecked: '#7B2119'}"/>-->
            </v-flex>
          </v-layout>
          <!-- <v-autocomplete v-model="xTableItemfirst"
            :items="sumFieldOptions"
            :label="'Count or BandWidth'"
            perpend-icon="table_chart"
          >
          </v-autocomplete> -->
          <v-select
            v-model="xTableItemfirst"
            :label="'Count or BandWidth'"
            :items="sumFieldOptions"
            :rules="allRules"
            @change="preview"
          ></v-select>
          <v-autocomplete v-model="item.value" :rules="allRules" v-for="(item, index) in xTableItem" :key="index"
            :items="sumFieldOptions"
            :label="'Count or BandWidth'"
                          @change="preview"
            perpend-icon="table_chart">
            <v-slide-x-reverse-transition slot="append-outer" mode="out-in">
              <v-icon :color="'warning'" @change="preview" @click="xTableItem.splice(index, 1); preview();" v-text="'delete'"/>
            </v-slide-x-reverse-transition>
          </v-autocomplete>
          <v-layout align-center justify-space-around v-if="xTableItem.length < sumFieldOptions.length - 1 && xTableItem.length < 2">
            <v-icon @click="xTableItem.push({ value: '' })">playlist_add</v-icon>
          </v-layout>
          <v-select v-model="interval" :rules="allRules" label="Interval time (Default Auto)"
                  :items="intervaltype" @change="preview"
                  required/>
          <v-text-field v-model="subFilter" :rules="allRules" @change="preview" label="Filter (Default *)" required/>
        </div>
        <div v-else-if="chartType === 'x-pie' || chartType === 'x-bar' || chartType === 'x-hbar'">
        <div v-if="chartType === 'x-pie'">
        <v-select
                  v-model="chartFunc"
                  :rules="allRules" label="Sort by"
                  :items="chartFuncPie"
                  @change="preview"
                  required/>
        </div>
        <div v-else>
        <v-select
                  v-model="chartFunc"
                  :rules="allRules" label="Sort by"
                  :items="chartFieldByteOptions"
                  @change="preview "
                  required/>
        </div>
          <v-text-field v-model="chartTopLimit"  :rules="allRules" @change="preview" label="Size of data in the chart (Default 10)" required/>
          <v-layout>
            <v-flex sm11>
        <v-autocomplete v-model="chartField" :rules="allRules" :label="'Dashboard field ('+ chartFieldOptions.length+' Field available)'"
                        :items="chartFieldOptions"
                        @change="preview"
                        required>
          <v-slide-x-reverse-transition slot="append-outer" mode="out-in"></v-slide-x-reverse-transition>
        </v-autocomplete>
            </v-flex>
            <v-flex sm5 mt-1 ml-1>
              <v-checkbox
                v-model="show_all_field"
                label="Advanced Field"
              ></v-checkbox>
              <!--<toggle-button :sync="true"-->
              <!--:value="false"-->
              <!--width="110"-->
              <!--height="26"-->
              <!--font-size="11"-->
              <!--v-model="show_all_field"-->
              <!--:labels="{checked: 'All Field', unchecked: 'Poppular Field'}"-->
              <!--:color="{checked: '#53A34E', unchecked: '#7B2119'}"/>-->
            </v-flex>
          </v-layout>
        <v-text-field v-model="subFilter" :rules="allRules" @change="preview" label="Filter (Default *)" required/>
      </div>
      <div v-else-if="chartType === 'x-timeBar'">
        <v-select v-model="interval" :rules="allRules" @change="preview" label="Interval time (Default Auto)"
                  :items="intervaltype"
                  required/>
      </div>
        <div v-else-if="chartType === 'x-map'">
          <v-text-field
            v-model="subFilter"
            :rules="allRules"
            label="Filter (Default *)"
            @change="preview"
            required/>
        </div>
        <div v-else-if="chartType === 'x-summary'">
        <v-text-field
          v-model="subFilter"
          :rules="allRules"
          label="Filter (Default *)"
          @change="preview"
          required/>
        </div>
      </v-card-text>
      <v-card-actions>
        <!--<v-btn color="deep-purple darken-4" @click.native="preview">Preview</v-btn>-->
        <v-spacer/>
        <v-btn
          slot="activator"
          fab
          large
          color="#00BFA5"
          icon
          @click="commit">
          <v-icon>arrow_forward</v-icon>
        </v-btn>
        <!-- <v-btn
          slot="activator"
          flat
          icon
          @click="$emit('close')">
          <v-icon>cancel</v-icon>
        </v-btn> -->
      </v-card-actions>
    </v-card>
  </v-form>

</template>

<script>
import VueScrollTo from 'vue-scrollto'

export default {
  components: {
    VueScrollTo
  },
  props: {
    maxY: {
      type: Number,
      default: 0
    },
    chartTypeOptions: {
      type: Array,
      default: function () {
        return []
      }
    },
    chartFieldOptions: {
      type: Array,
      default: function () {
        return []
      }
    },
    chartFieldByteOptions: {
      type: Array,
      default: function () {
        return []
      }
    },
    fieldResponse: {
      type: String,
      default: ''
    },
    sumFieldOptions: {
      type: Array
    },
    index_list: {
      type: Array
    },
    index: {
      type: String
    },
    preview_slices: {
      type: []
    },
    show_all_field: {
      type: Boolean
    }
  },
  data () {
    return {
      slice: {},
      xTableItems: [{
        value: ''
      }],
      xTableItem: [],
      xTableItemfirst: null,
      xTableFields: [],
      xTableOptions: [],
      xTableFieldsCustom: [],
      xTableOptionsCustom: [],
      xTableFieldsValue: [],
      fieldCustom: [],
      optionsCustom: [],
      // timestamp: { text: '@timestamp', value: '@timestamp' },
      chartName: '',
      chartType: '',
      chartFunc: '' || 'Count',
      chartFuncPie: '' || [{
        text: 'Count',
        value: 'count'
      }],
      chartField: '',
      chartFieldStart: '',
      chartFieldEnd: '',
      chartTopLimit: 10,
      index_now: '',
      chartTopLimitSankey: 5,
      subFilter: '*',
      valid: true,
      allRules: [
        v => !!v || 'This is required'
      ],
      interval: 'auto',
      intervaltype: [
        {
          text: 'Auto',
          value: 'auto'
        },
        {
          text: 'minutes (m)',
          value: '1m'
        },
        {
          text: 'hours (h)',
          value: '1h'
        },
        {
          text: 'days (d)',
          value: '1d'
        },
        {
          text: 'weeks (w)',
          value: '1w'
        },
        {
          text: 'months (M)',
          value: '1M'
        },
        {
          text: 'years (y)',
          value: '1y'
        }
      ]
    }
  },
  created () {
    this.index_now = this.index
  },
  methods:
    {
    preview () {
      if (this.$refs.form.validate()) {
        if (this.chartType === 'x-table') {
          this.xTableFields = this.xTableItems.map(item => ({ key: item.value, sortable: true }))
          this.xTableFields.unshift({ key: '@timestamp', sortable: true })
          this.xTableFields.push({ key: 'rawData', sortable: false })
          this.xTableOptions = this.xTableItems.map(item => ({ text: item.value, value: item.value }))
        }
        if (this.chartType === 'x-tableCustom') {
          this.xTableFieldsCustom = this.xTableItems.map(item => ({ key: item.value, sortable: true }))
          // this.xTableFieldsCustom.unshift({ key: this.timestamp.value, sortable: true })
          this.xTableOptionsCustom = this.xTableItems.map(item => ({ text: item.value, value: item.value }))
          // this.xTableOptionsCustom.unshift({ text: this.timestamp.value, value: this.timestamp.value })
          this.fieldCustom = this.xTableItem.map(item => ({ key: item.value, sortable: true }))
          this.fieldCustom.unshift({ key: this.xTableItemfirst, sortable: true })
          this.optionsCustom = this.xTableItem.map(item => ({ text: item.value, value: item.value }))
          this.optionsCustom.unshift({ text: this.xTableItemfirst, value: this.xTableItemfirst })
        }
        this.slice = {}
        this.slice = {
          slice_id: new Date().getTime().toString(),
          chartName: this.chartName,
          chartType: this.chartType,
          index: this.index_now,
          subFilter: this.subFilter,
          x: 0,
          y: 8,
          i: this.chartType + new Date().getTime().toString(),
          ...(this.chartType === 'x-sankey' && {
            w: 12,
            h: 1.6,
            orderby: this.chartFunc === 'count'
              ? '_count'
              : 'sumbyte',
            fieldsum: this.chartFunc === 'count'
              ? ''
              : this.chartFunc,
            field_st: this.chartFieldStart + '.keyword',
            field_nd: this.chartFieldEnd + '.keyword',
            topLimit: this.chartTopLimitSankey
          }),
          ...(this.chartType === 'x-summary' && {
            w: 12,
            h: 1
          }),
          ...(this.chartType === 'x-map' && {
            w: 6,
            h: 2
          }),
          ...(this.chartType === 'x-table' && {
            w: 12,
            h: 1.7,
            fields: this.xTableFields,
            options: this.xTableOptions
          }),
          ...(this.chartType === 'x-tableCustom' && {
            w: 12,
            h: 1.2,
            fields: this.xTableFieldsCustom,
            options: this.xTableOptionsCustom,
            fieldCustom: this.fieldCustom,
            optionsCustom: this.optionsCustom,
            intervalTimeBar: this.interval
          }),
          ...((this.chartType === 'x-bar' || this.chartType === 'x-hbar' || this.chartType === 'x-pie') && {
            w: 12,
            h: 1.5,
            orderby: this.chartFunc === 'count'
              ? '_count'
              : 'sumbyte',
            fieldsum: this.chartFunc === 'count'
              ? ''
              : this.chartFunc,
            field: this.chartField + '.keyword',
            topLimit: this.chartTopLimit
          }),
          ...(this.chartType === 'x-timeBar' && {
            w: 12,
            h: 1,
            intervalTimeBar: this.interval
          })
        }
        this.$emit('preview', this.slice)
      }
    },
    commit () {
      if (this.$refs.form.validate()) {
        if (this.chartType === 'x-table') {
          this.xTableFields = this.xTableItems.map(item => ({ key: item.value, sortable: true }))
          this.xTableFields.unshift({ key: '@timestamp', sortable: true })
          this.xTableFields.push({ key: 'rawData', sortable: false })
          this.xTableOptions = this.xTableItems.map(item => ({ text: item.value, value: item.value }))
        }
        if (this.chartType === 'x-tableCustom') {
          this.xTableFieldsCustom = this.xTableItems.map(item => ({ key: item.value, sortable: true }))
          // this.xTableFieldsCustom.unshift({ key: this.timestamp.value, sortable: true })
          this.xTableOptionsCustom = this.xTableItems.map(item => ({ text: item.value, value: item.value }))
          // this.xTableOptionsCustom.unshift({ text: this.timestamp.value, value: this.timestamp.value })
          this.fieldCustom = this.xTableItem.map(item => ({ key: item.value, sortable: true }))
          this.fieldCustom.unshift({ key: this.xTableItemfirst, sortable: true })
          this.optionsCustom = this.xTableItem.map(item => ({ text: item.value, value: item.value }))
          this.optionsCustom.unshift({ text: this.xTableItemfirst, value: this.xTableItemfirst })
        }
        this.slice = {
          slice_id: new Date().getTime().toString(),
          chartName: this.chartName,
          chartType: this.chartType,
          index: this.index_now,
          subFilter: this.subFilter,
          x: 0,
          y: this.maxY + 1,
          i: this.chartType + new Date().getTime().toString(),
          ...(this.chartType === 'x-sankey' && {
            w: 12,
            h: 1.6,
            orderby: this.chartFunc === 'count'
                      ? '_count'
                      : 'sumbyte',
            fieldsum: this.chartFunc === 'count'
              ? ''
              : this.chartFunc,
            field_st: this.chartFieldStart + '.keyword',
            field_nd: this.chartFieldEnd + '.keyword',
            topLimit: this.chartTopLimitSankey
          }),
          ...(this.chartType === 'x-summary' && {
            w: 6,
            h: 1
          }),
          ...(this.chartType === 'x-map' && {
            w: 6,
            h: 2
          }),
          ...(this.chartType === 'x-table' && {
            w: 12,
            h: 2.9,
            fields: this.xTableFields,
            options: this.xTableOptions
          }),
          ...(this.chartType === 'x-tableCustom' && {
            w: 12,
            h: 1.2,
            fields: this.xTableFieldsCustom,
            options: this.xTableOptionsCustom,
            fieldCustom: this.fieldCustom,
            optionsCustom: this.optionsCustom,
            intervalTimeBar: this.interval
          }),
          ...((this.chartType === 'x-bar' || this.chartType === 'x-hbar' || this.chartType === 'x-pie') && {
            w: 6,
            h: 1,
            orderby: this.chartFunc === 'count'
                      ? '_count'
                      : 'sumbyte',
            fieldsum: this.chartFunc === 'count'
              ? ''
              : this.chartFunc,
            field: this.chartField + '.keyword',
            topLimit: this.chartTopLimit
          }),
          ...(this.chartType === 'x-timeBar' && {
            w: 6,
            h: 1,
            intervalTimeBar: this.interval
          })
        }
        this.$emit('commit', this.slice)
        VueScrollTo.scrollTo('#down')
      }
    },
    setRefreshIndex () {
      this.$emit('setRefreshIndex', this.index_now, this.show_all_field)
    }
  },
  watch: {
    show_all_field: {
      handler: function () {
        if (this.show_all_field === true) {
          this.$emit('setRefreshIndex', this.index_now, this.show_all_field)
        } else if (this.show_all_field === false) {
          this.$emit('setRefreshIndex', this.index_now, this.show_all_field)
        }
      }
    },
    index: {
      handler: function () {
        this.index_now = this.index
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/DashboardDialogAddChart.vue